const initState = {}

export function upload(state = initState, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Upload/reducer.js